import { FormattedMessage, useIntl } from 'react-intl';
import { commonMessages } from '../../../components/atoms/CommonMessages/messages';
import { ContentBody } from '../../../components/atoms/ContentBody/ContentBody';
import { ScreenWrapper } from '../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { Header } from '../../../components/organisms/Header/Header';
import { PageView } from '../../../models/analytics';
import { ProviderListHeader } from '../../components/ProvidersList/ProviderListHeader';
import { GermanStates } from '../../../models/provider';
import {
  List,
  ProvidersListWrapper,
  StateListItem,
  StyledStateButton,
  StyledStateContainer,
} from '../../components/ProvidersList/ProvidersList.styles';
import { GradientList } from '../../../components/molecules/GradientList/GradientList';
import { Caption } from '../../../components/atoms/Text/Text';
import { BranchHeader } from '../../components/ProvidersList/BranchHeader';
import { messages } from './messages';

export type ProviderItemProps = {
  title: string;
  onClick: () => void;
};

export const ProviderItem = ({ title, onClick }: ProviderItemProps) => {
  return (
    <StateListItem>
      <StyledStateButton onClick={onClick} data-test="providerListItem" data-testid={title}>
        <StyledStateContainer>
          <Caption as="span" data-test="providerName" translate="no">
            {title}
          </Caption>
        </StyledStateContainer>
      </StyledStateButton>
    </StateListItem>
  );
};

export type RegionPickerProps = {
  states: GermanStates[];
  onSelectState: (state: GermanStates) => void;
  onBack: () => void;
  groupDisplayName: string;
  iconUrl: string;
};

export const RegionPicker = ({
  states,
  onBack,
  onSelectState,
  groupDisplayName,
  iconUrl,
}: RegionPickerProps) => {
  const intl = useIntl();

  return (
    <ScreenWrapper>
      <Header onBack={onBack} pageView={PageView.PROVIDER_REGION_PICKER_SCREEN} />
      <ContentBody fullWidth>
        <ProviderListHeader
          placeholder={intl.formatMessage(commonMessages.search)}
          headerMessage={messages.selectYourState}
        >
          <BranchHeader
            iconUrl={iconUrl}
            headerMessage={
              <FormattedMessage {...messages.providerPerState} values={{ groupDisplayName }} />
            }
          />
        </ProviderListHeader>
        <ProvidersListWrapper data-testid="provider-region-list">
          <GradientList>
            <List>
              {states.map((state) => (
                <ProviderItem key={state} onClick={() => onSelectState(state)} title={state} />
              ))}
            </List>
          </GradientList>
        </ProvidersListWrapper>
      </ContentBody>
    </ScreenWrapper>
  );
};
